export default "__VITE_ASSET__2370b7c3__"